import {
  pageInfo,
  taskPkgStoreDetail,
  approveAgreeSubmit,
  approveRefuseSubmit,
  submitImport,
  taskPkgEditInit,
  taskPkgEdit,
  homePush,
  homeRanking,
  deleteData,
  exportData,
  exportPersonnelPoints
} from './../api';
import {taskPkgTypeSelect, taskPkgStatusSelect, taskPkgAreaCitySelect, customerSelect} from '../../../../api'
const taskApproval = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    taskUpdInitObj: null,
    taskPkgTypeObj: null,
    taskPkgStatusObj: null,
    taskPkgAreaObj: null,
    taskPkgEditObj: null,
    taskPkgDetailObj: null,
    agreeObj: null,
    rejectObj: null,
    customerObj: null,
    personalPointsExportObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || [])
    },
    /**
     * 初始化
     */
    TASK_PKG_EDIT_INIT(state, data) {
      state.taskUpdInitObj = data;
    },
    /**
     * 修改提交
     */
    TASK_PKG_EDIT(state, data) {
      state.taskPkgEditObj = data;
    },
    /**
     * 详情
     */
    TASK_PKG_DETAIL(state, data) {
      state.taskPkgDetailObj = data;
    },

    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    /**
     * 个人积分导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_PERSONNEL_POINTS_DATA(state, data) {
      state.personalPointsExportObj = data;
    },
    /**
     * 任务类型
     */
    TASK_PKG_TYPE(state, data){
      state.taskPkgTypeObj = data.obj;
    },
    /**
     * 任务状态
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_STATUS(state, data){
      state.taskPkgStatusObj = data.obj;
    },
    /**
     * 适用区域
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_AREA_CITY(state, data){
      state.taskPkgAreaObj = data.obj;
    },
    /**
     * 适用区域
     * @param state
     * @param data
     * @constructor
     */
    CUSTOMER(state, data){
      state.customerObj = data.obj;
    },

    /**
     * 同意
     * @param state
     * @param data
     * @constructor
     */
    APPROVE_AGREE_SUBMIT(state, data){
      state.agreeObj = data;
    },
    /**
     * 拒绝
     * @param state
     * @param data
     * @constructor
     */
    APPROVE_REFUSE_SUBMIT(state, data){
      state.rejectObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 修改提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgEdit({ commit }, obj) {
      let resp = await taskPkgEdit(obj);
      commit('TASK_PKG_EDIT', resp);
    },
    /**
     * 初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgEditInit({ commit }, obj) {
      let resp = await taskPkgEditInit(obj);
      commit('TASK_PKG_EDIT_INIT', resp);
    },
    /**
     * 查看详情
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgStoreDetail({ commit }, obj) {
      let resp = await taskPkgStoreDetail(obj);
      commit('TASK_PKG_DETAIL', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //个人积分导出
    async exportPersonnelPoints({ commit }, obj) {
      let resp = await exportPersonnelPoints(obj);
      commit('EXPORT_PERSONNEL_POINTS_DATA', resp);
    },
    /**
     * 任务类型
     */
    async taskPkgTypeSelect({commit}, obj) {
      let resp = await taskPkgTypeSelect(obj);
      commit('TASK_PKG_TYPE', resp);
    },
    /**
     * 任务状态
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgStatusSelect({commit}, obj) {
      let resp = await taskPkgStatusSelect(obj);
      commit('TASK_PKG_STATUS', resp);
    },
    /**
     * 适用区域
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgAreaCitySelect({commit}, obj) {
      let resp = await taskPkgAreaCitySelect(obj);
      commit('TASK_PKG_AREA_CITY', resp);
    },

    /**
     * 同意
     */
    async approveAgreeSubmit({commit}, obj) {
      let resp = await approveAgreeSubmit(obj);
      commit('APPROVE_AGREE_SUBMIT', resp);
    },
    /**
     * 拒绝
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async approveRefuseSubmit({commit}, obj) {
      let resp = await approveRefuseSubmit(obj);
      commit('APPROVE_REFUSE_SUBMIT', resp);
    },

    /**
     * 经销商
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async customerSelect({commit}, obj) {
      let resp = await customerSelect(obj);
      commit('CUSTOMER', resp);
    },
  }
}
export default taskApproval



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskApproval/store/taskApproval.store.js